import { Role } from '@orgbrain/roles';
export class BoardMember {
  id: string;
  _id: string;
  first_name: string;
  last_name: string;
  firstName: string;
  lastName: string;
  displayName?: string;
  email: string;
  role: string;
  rolesForBoard: string;
  roles: Role[];
  logoUrl: string;
  votingright?: boolean;
  invitationCode?: string;
  sortIndex?: number;
  canBeInvited?: boolean;
  canBeInvitedGA?: boolean;
  isDeletedFlag: boolean;
  proxyWelcomeText?: string;
  proxyUploadedAttachment?: string;
  canVoteByDefaultIfNotRestricted?: boolean;
  canVoteInTheoryAfterSomeMorePermissionsGranted?: boolean;
  boardMemberAttendanceStatus?: string;
}
